import { useQueryParams } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { FilterMenuButton } from '@calendly/ui/components/filter-menu';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { omitBy } from 'lodash-es';
import { forwardRef, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { pushQueryParams } from 'actions/core/navigation';
import { FilterMenuTriggerIcon, SchedulingFilterMenu, ensureFilterMenuPortalRoots } from 'components/cui_filter_menu';
import { getAppliedFilters } from '../utils';
import { DropdownContent } from './filter_dropdown';
const containerCss = "cwn7zsl";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const filterByCss = "f51g2g7";
const FilterBy = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(filterByCss, props.className)} />;
});
const numberWrapperCss = "n1ht6b1";
const NumberWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(numberWrapperCss, props.className)} />;
});
const triggerLabelGapCss = "t1cz4cbo";
const TriggerLabel = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(triggerLabelGapCss, props.className)} />);
const getButtonText = appliedFilters => <FilterBy>
    <BodyText inline as="div">{I18n.t('publisher.event_types.filters.button')}</BodyText>
    {appliedFilters > 0 && <NumberWrapper>
        {appliedFilters}
      </NumberWrapper>}
  </FilterBy>;
export const PollFiltersButton = () => {
  const params = useQueryParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const isPhone = useDeviceType('isPhone');
  const appliedFilters = getAppliedFilters(params.status);
  const handleOpenChange = useCallback(nextIsOpen => {
    if (nextIsOpen) {
      ensureFilterMenuPortalRoots();
    }
    setIsOpen(nextIsOpen);
  }, []);
  const onSearch = useCallback(({
    status
  }) => {
    const searchParams = omitBy({
      ...params,
      status
    }, value => value.length === 0);
    dispatch(pushQueryParams(searchParams));
  }, [dispatch, params]);
  return <Container>
      <SchedulingFilterMenu isOpen={isOpen} onOpenChange={handleOpenChange} contentMinWidth="comfortable" responsive placement="bottom start">
        <FilterMenuButton hasSelection={appliedFilters.length > 0} data-calendly-label="filter-button" aria-label={I18n.t('publisher.event_types.filters.button')} disableArrow={isPhone}>
          <TriggerLabel>
            <FilterMenuTriggerIcon selected={appliedFilters.length > 0} />
            {!isPhone && getButtonText(appliedFilters.length)}
          </TriggerLabel>
        </FilterMenuButton>
        {isOpen && <DropdownContent contentTestId="scheduling-filter-menu-content" aria-label={I18n.t('publisher.event_types.filters.button')} initialStatus={appliedFilters} onSearch={onSearch} />}
      </SchedulingFilterMenu>
    </Container>;
};

require("./filter_button.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./filter_button.js");